__webpack_require__.p = "/tokens-marketplace-ribbon/account-setup/";